const DBKEY = 'context';

export const readLocalDb = (key: string) => JSON.parse(localStorage.getItem(DBKEY) || '{}')[key];

export const writeLocalDb = (key: string, value: any) => {
    const stack = JSON.parse(localStorage.getItem(DBKEY) || '{}');
    localStorage.setItem(DBKEY, JSON.stringify({ ...stack, [key]: value}))
}